module.exports = __webpack_public_path__ + "static/media/170-greece.3d18107a.svg";